import type { M365AcquisitionsNetworkLog } from "owa-graph-schema";

// Store for network logs as an array
const addinNetworkLogs: M365AcquisitionsNetworkLog[] = [];

/**
 * Maximum number of network logs to keep (to avoid memory issues)
 */
const MAX_NETWORK_LOGS = 100;

/**
 * Adds a network log entry for add-in operations
 * @param logEntry The network log entry to store
 */
function addAddinNetworkLog(logEntry: M365AcquisitionsNetworkLog): void {
    // Add to the array
    addinNetworkLogs.push(logEntry);
    
    // Trim logs if they exceed the maximum size
    if (addinNetworkLogs.length > MAX_NETWORK_LOGS) {
        // Remove oldest entries (shift removes from the beginning of the array)
        addinNetworkLogs.splice(0, addinNetworkLogs.length - MAX_NETWORK_LOGS);
    }
}

/**
 * Adds multiple network log entries for add-in operations
 * @param logEntries Array of network log entries to store
 */
export function addAddinNetworkLogs(logEntries: M365AcquisitionsNetworkLog[]): void {
    logEntries.forEach(logEntry => {
        addAddinNetworkLog(logEntry);
    });
}

/**
 * Returns all collected network logs as a serialized string
 */
export function getAddinNetworkLogs(): M365AcquisitionsNetworkLog[] {
    return addinNetworkLogs;
}
